<template>
  <footer class="footer">
    <div class="footer-top">
      <div class="container">
        <div class="row">
          <div class="col-md-3 col-sm-5">
            <router-link to="/" class="c-footer__logo" title="Dan Advance LLC"><img src="./../../static/images/dan-advance-logo.svg" alt="Dan Advance LLC" /></router-link>
            <p class="ubuntu font-light small-p"><!--Dan Advance LLC<br>770 Ork wood Road<br>Brooklyn, NY 53717--><span style="font-size:0.9em">C/O Cohen Saban Charitable Trust,<br> 112 West 34th Street Fl. 18,<br>New York, NY 10120</span></p>
            <p class="ubuntu font-light small-p"><!--Dan Advance Reg. No. : 4183--><br>Contact No : <a href="tel:+1-877-2271-060" class="gray10-c">+1-877-2274-060</a></p>
          </div>
          <div class="col-md-6 col-sm-7">
            <div class="footer-contact-us">
              <ul>
                <li>
                  <span class="verticle-middle"><router-link to="/" class="header-link"><img src="./../../static/images/icons/support.png" /></router-link></span><div class="footer-contact-details verticle-middle">
                        <h6 class="footer-title ubuntu font-bold mar-no blue-c">Customer Care</h6>   
                        <p class="ubuntu font-light small-p mar-no">Monday – Friday: 9:00 a.m. – 5:00 p.m.<br>
                        Saturday: 9:00 a.m. – 12:00 p.m.<br>
                        Sunday: closed</p>
                  </div>
                </li>
                <li>
                    <span class="verticle-middle"><router-link to="/" class="header-link"><img src="./../../static/images/icons/call.png" /></router-link></span><div class="footer-contact-details verticle-middle">
                      <h6 class="footer-title ubuntu font-bold mar-no">Phone : <a href="tel:+1-877-2274-060"><span class="blue-c">+1-877-2274-060</span></a></h6>   
                    </div>
                </li>
                <li>
                    <span class="verticle-middle"><router-link to="/" class="header-link"><img src="./../../static/images/icons/mail.png" /></router-link></span><div class="footer-contact-details verticle-middle">
                      <h6 class="footer-title ubuntu font-bold mar-no">Email : <a href="mailto:info@danadvance.com"><span class="blue-c">info@danadvance.com</span></a></h6>   
                    </div>
                  </li>
              </ul>
            </div>
          </div>
          <div class="col-md-3 col-sm-12">
            <h6 class="footer-title ubuntu font-bold mar-no blue-c-2">Quick Links</h6>   
            <ul class="footer-extra-link">
                <li class="list-style-none"><router-link to="/"><span class="ubuntu small-p green1-c font-regular">Home</span></router-link></li>
                <li class="list-style-none"><router-link to="/mca-market"><span class="ubuntu small-p green1-c font-regular">MAC Market</span></router-link></li>
                <li class="list-style-none"><router-link to="/about"><span class="ubuntu small-p green1-c font-regular">About</span></router-link></li>
                <li class="list-style-none"><router-link to="/contact"><span class="ubuntu small-p green1-c font-regular">Contact Us</span></router-link></li>
 
            </ul>
            <ul class="social-links">
              <li><a href="https://www.facebook.com/Dan-Advance-2743088639052636" target="_blank" class="header-link"><img src="./../../static/images/icons/s-fac.png" width="100%" /></a>
              </li><li><a href="https://twitter.com/danadvance" target="_blank" class="header-link"><img src="./../../static/images/icons/s-twi.png" width="100%" /></a>
              </li><li><a href="https://www.linkedin.com/company/dan-advance" target="_blank" class="header-link"><img src="./../../static/images/icons/s-link.png" width="100%" /></a></li>
            </ul>
          </div>
        </div>
      </div>
    </div>
    <div class="footer-bottom gray-b">
      <div class="container">
        <div class="row">
              <div class="col-md-5">
                <ul class="footer-navigation">
                  <li><router-link to="/terms-conditions" ><p class="ubuntu font-light mar-no small-t">Terms and Conditions</p></router-link></li>
                  <li><router-link to="/privacy-policy" ><p class="ubuntu font-light mar-no small-t">Privacy Policy</p></router-link></li>
                </ul>
              </div><div class="col-md-7">
                <p class="ubuntu font-light mar-no float-right small-t">&copy; 2019 Dan Advance LLC. All Rights Reserved. </p>
              </div>  
            </div>
      </div>
    </div>
  </footer>
</template>
<script>
export default{
  name: 'Footer'
}
</script>
<style>
.footer-contact-us ul li a span {
    width: auto;
}
</style>


// WEBPACK FOOTER //
// src/components/Footer.vue